(() => {
  const dialog = document.getElementById('Z30LegalGuaranteeDialog');

  if (!dialog || typeof dialog.showModal !== 'function') return;

  let lastTrigger = null;

  const openDialog = (trigger) => {
    lastTrigger = trigger;
    dialog.showModal();
    document.body.classList.add('z30-legal-dialog-open');
  };

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-z30-legal-open]');
    if (openTrigger) {
      event.preventDefault();
      openDialog(openTrigger);
      return;
    }

    if (event.target.closest('[data-z30-legal-close]') || event.target === dialog) {
      closeDialog();
    }
  });

  dialog.addEventListener('close', () => {
    document.body.classList.remove('z30-legal-dialog-open');
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  });
})();
